<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/userList/">Users</a></li>
      <li class="breadcrumb-item active" aria-current="page">User Update</li>
    </ol>
  </nav>
  <form>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black"> User Details</h2>
          <div class="row mt-3">
            <div class="col-md-12 col-md-8">
              <div class="row">

                <div class="col-md-3 required">
                  <div class="form-group ">
                    <label class="control-label" for="firstName">First Name</label>
                    <input type="text" id="firstName" [(ngModel)]="viewUser.firstName"  [ngModelOptions]="{standalone: true}" class="form-control"
                           (blur)="typeFirstName()" [ngClass]="{'is-invalid':statusText1}"  onkeypress="return event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 97 && event.charCode <= 122 || event.charCode == 32" autocomplete="off" required>
                  </div>
                </div>

                <div class="col-md-3 required">
                  <div class="form-group ">
                    <label class="control-label" for="lastName">Last Name</label>
                    <input type="text" id="lastName" [(ngModel)]="viewUser.lastName"  [ngModelOptions]="{standalone: true}" class="form-control"
                           (blur)="typeLastName()" [ngClass]="{'is-invalid':statusText2}"  onkeypress="return event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 97 && event.charCode <= 122 || event.charCode == 32" autocomplete="off" required>
                  </div>
                </div>

                <div class="col-md-3 required">
                  <div class="form-group ">
                    <label class="control-label" for="contactNumber">Phone Number</label>
                    <input type="text" id="contactNumber" onkeypress='return event.charCode >= 48 && event.charCode <= 57' [(ngModel)]="viewUser.mobile" [ngModelOptions]="{standalone: true}" (blur)="validateMobile()"  [ngClass]="{'is-invalid':statusText3}"  maxlength="10" class="form-control"  required>
                  </div>
                </div>

              </div>

              <div class="row">
                <div class="col-md-3 required">
                  <div class="form-group">
                    <label class="control-label" for="email">Email</label>
                    <input type="text" id="email" [(ngModel)]="viewUser.email"  [ngModelOptions]="{standalone: true}"  (blur)="validateEmail()" [ngClass]="{'is-invalid':statusText4}" class="form-control"  required>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-12 mb-1 text-danger fw-500" *ngIf="statusText1 || statusText2 || statusText3 || statusText4">Please Enter Mandatory Fields</div>
      <div class="col">
        <div class="inner-box">
          <div class="row mt-3">
            <div class="col">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="control-label" for="invoiceType"><b>Assign Roles</b></label>
                    <select  id="invoiceType" class="form-control" [(ngModel)]="role.name" [ngModelOptions]="{standalone: true}" (click)="click()" >
                      <option  *ngFor="let i of auth" [ngValue]="i.name">{{i.name | replaceStatus}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-8">
                  <table class="table">
                    <thead>
                    <tr>
                      <th class="control-label">Assigned Roles</th>
                      <th>Remove</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let r of usersRoles">
                      <td>{{r.userRole | replaceStatus}}</td>
                      <td>
                        <a (click)="removeProduct(r)">
                          <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                            <defs><style>.a{fill:#848484;}</style></defs>
                            <path class="a" d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z" transform="translate(-7.5 -4.5)"/>
                          </svg>
                        </a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>

<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button type="reset" routerLink="/admin/userList" id="cancel" class="btn btn-cancel">Cancel</button>
      <button type="submit" (click)="submit()" id="save" class="btn btn-orange ml-2">Save</button>
    </div>
  </div>
</div>
